import { memo, type ReactNode, useMemo } from 'react';
import {
    Menu,
    type MenuItem,
    PageHead,
    type PageHeadProps,
    type PageHeadRenderMenuProps,
    Text,
} from '@direct-frontend/components';

export interface HeaderViewProps {
    /** Название товара */
    name: string;
    /** Флаг нового товара */
    isNew: boolean;
    /** Caption с характеристиками */
    caption?: ReactNode;
    /** Props для label статуса */
    labels?: PageHeadProps['labels'];
    /** Пункты меню */
    menuItems?: MenuItem[];
    /** Дополнительный контент (модалки и т.д.) */
    additionalContent?: ReactNode;
}

export const HeaderView = memo<HeaderViewProps>(function HeaderView({
    name,
    isNew,
    caption,
    labels,
    menuItems = [],
    additionalContent,
}) {
    const HeadTitle = (
        <Text maxLines={3} size="xl" bold>
            {name || 'Название товара'}
        </Text>
    );

    const renderMenu = useMemo(() => {
        const renderMenuFunction = (props: PageHeadRenderMenuProps) => (
            <Menu {...props} items={menuItems} logNode="ProductVariantHeaderMenu" aria-label="Действия с товаром" />
        );

        return menuItems.length > 0 ? renderMenuFunction : undefined;
    }, [menuItems]);

    return (
        <>
            <PageHead
                title={HeadTitle}
                breadcrumbs={
                    isNew
                        ? undefined
                        : [
                              {
                                  text: 'Редактирование товара',
                              },
                          ]
                }
                labels={isNew ? undefined : labels}
                caption={caption}
                renderMenu={renderMenu}
            />
            {additionalContent}
        </>
    );
});
